import React from 'react';
export function ProductShowcase() {
  const row1Colors = ['bg-blue-800', 'bg-green-800', 'bg-red-800', 'bg-purple-800', 'bg-gray-700', 'bg-orange-800'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-241">
      <div className="max-w-5xl mx-auto text-center" data-id="element-242">
        <div data-id="element-243">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-244">
            <span className="text-xl" data-id="element-245">🔬</span> FISICA PRONTA
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-[#00FF84]" data-id="element-246">
            FISICA PRONTA: Il Sistema Completo
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-247">
            <p className="text-xl md:text-2xl text-white font-bold" data-id="element-248">
              6 volumi organizzati per nuclei tematici e anno scolastico.
            </p>
            <p className="text-base md:text-lg text-white/70 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-249">
              120 lezioni con guida passo-passo. 6 bonus strategici. Tutto
              pronto all'uso da oggi.
            </p>
          </div>
        </div>

        {/* Grid Showcase */}
        <div className="relative max-w-3xl mx-auto mb-16" data-id="element-250">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3 mb-6" data-id="element-251">
            {row1Colors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-brand-accent rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-252">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-253">
                  {i + 1}°
                </span>
              </div>)}
          </div>

          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-brand-accent text-brand-accent px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-254">
            6 VOLUMI "CHIAVI IN MANO"
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto mt-12" data-id="element-255">
          {['✅ Allineato ai quadri di riferimento MIUR', '✅ Spiegazioni semplificate', '✅ Verifiche con soluzioni', '✅ Inclusione BES/DSA'].map((item, i) => <div key={i} className="bg-brand-card border border-brand-accent px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-256">
              <span className="font-medium text-white/90 text-sm md:text-base" data-id="element-257">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}